
import { useState } from 'react';
import { Link } from 'react-router-dom';

interface AffiliateDisclosureProps {
  variant?: 'banner' | 'inline';
}

export default function AffiliateDisclosure({ variant = 'banner' }: AffiliateDisclosureProps) {
  const [dismissed, setDismissed] = useState(false);

  if (variant === 'inline') {
    return (
      <div className="flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 text-xs text-amber-800">
        <i className="ri-information-line text-amber-500 text-base flex-shrink-0 mt-0.5"></i>
        <p>
          <strong>Affiliate Disclosure:</strong> Some links on this page are affiliate links. If you click and make a purchase, we may earn a small commission at no extra cost to you. We only recommend products we genuinely love. {' '}
          <Link to="/contact" className="underline hover:text-amber-900 cursor-pointer">Learn more</Link>.
        </p>
      </div>
    );
  }

  if (dismissed) return null;

  return (
    <div className="w-full bg-amber-50 border-b border-amber-200">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className="ri-information-line text-amber-600 text-base"></i>
          </div>
          <p className="text-xs text-amber-800 leading-snug">
            <strong>Affiliate Disclosure:</strong> This site contains affiliate links. We may earn a commission when you click and purchase — at no extra cost to you. We only recommend products we genuinely love. 🐾{' '}
            <Link to="/contact" className="underline font-medium hover:text-amber-900 cursor-pointer whitespace-nowrap">
              Learn more
            </Link>
          </p>
        </div>
        <button
          onClick={() => setDismissed(true)}
          aria-label="Dismiss disclosure"
          className="w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full hover:bg-amber-200 transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-amber-700 text-base"></i>
        </button>
      </div>
    </div>
  );
}
